// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3uvO3","col":"styles_col__1-Ye_"};